
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkBOMGrid extends Serenity.EntityGrid<JobWorkBOMRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWorkBOM'; }
        protected getDialogType() { return JobWorkBOMDialog; }
        protected getIdProperty() { return JobWorkBOMRow.idProperty; }
        protected getInsertPermission() { return JobWorkBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkBOMRow.localTextPrefix; }
        protected getService() { return JobWorkBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}